import { Checkbox } from '@mantine/core';

import { useUpdateMethodByMethodData } from '../hooks/use-update-method-by-method-data';

import type { TPaymentMethod } from '../store/types';

type Props = {
  method: TPaymentMethod;
};

export const MethodActiveStatus = (props: Props): React.ReactElement => {
  const { method } = props;

  const {
    isLoading,
    handleMethodUpdateByMehtodData,
  } = useUpdateMethodByMethodData();

  const onMethodActiveChange = () => {
    handleMethodUpdateByMehtodData({
      methodId: method.id,
      active: !method.active,
    });
  };

  return (
    <Checkbox
      style={{ display: 'flex', justifyContent: 'center' }}
      checked={method.active}
      disabled={isLoading}
      onChange={onMethodActiveChange}
    />
  );
};
